import React from "react";
import PageContainer from "./layout/PageContainer.js";
import HomeHero from "./HomeHero.js";
import BrainDump from "./BrainDump.js";
import OpenActionBanner from "./OpenActionBanner.js";

/**
 * Home is Quick Clarity only. Deep Reflection (EIER) lives under TOOLS in the menu.
 * An open action may appear above the entry; it never blocks a new reflection.
 */
const HomePage = ({
  isSubscriber,
  verifiedEmail,
  isVerified,
  personalEntries,
  setPersonalEntries,
  setIsSubscriber,
  setIsPaidSubscriber
}) => (
  <PageContainer className="home-page guided-reflection">
    <HomeHero />
    <div className="home-mode-panel">
      <OpenActionBanner verifiedEmail={verifiedEmail} />
      <BrainDump
        embedded
        verifiedEmail={verifiedEmail}
        personalEntries={personalEntries}
        setPersonalEntries={setPersonalEntries}
        isSubscriber={isSubscriber}
        setIsSubscriber={setIsSubscriber}
        setIsPaidSubscriber={setIsPaidSubscriber}
        isVerified={isVerified}
      />
    </div>
  </PageContainer>
);

export default HomePage;
